import { render, staticRenderFns } from "./NewGoodByUser.vue?vue&type=template&id=9014a1c8&"
import script from "./NewGoodByUser.vue?vue&type=script&lang=js&"
export * from "./NewGoodByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports